import React, { Component, useState, useEffect } from "react";
import {
  login,
  page,
  ContentDetails,
  RelatedContent,
  GetPlayurl,
} from "../../Model/Content"; //Include Home
import { CheckUser, getGeoInfo } from "../../Model/Users";
import { isMobile } from "react-device-detect";
import {Watchtrailer} from "../../components/vidjs/mainPlayer";
import VideoPlayer from "react-awesome-player";
import videojs from "video.js";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import Slider from "react-slick";
import videojsqualityselector from "videojs-hls-quality-selector";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import BarLoader from "react-spinners/BarLoader";

import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import { SVGIcons, ImgIcons, VirsionCheck, Appsflyer, branchIO } from "../../Helpers/Common";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

var options = {};
function onVideoPlay(player) { }
function onPlayerReady(player) {
  var player = videojs("my-player");
  var options = {};

  var player = videojs("my-player", options, function onPlayerReady() {
    videojs.log("Your player is ready!");
    this.play();
    this.on("ended", function () {
      videojs.log("Awww...over so soon?!");
    });
  });

  var videojs = require("video.js");

  require("videojs-hls-quality-selector");

  var player = videojs("my-video");

  player.hlsQualitySelector({
    displayCurrentQuality: true,
  });

  return player;
}

export function WatchTrailer(props) {
  var player = {};
  const playerRef = React.useRef();
  const [contentdata, setContent] = useState(0);
  const [dataloaded, setDataloaded] = useState(0);
  const [RelatedContentdata, setRelatedcontent] = useState(0);
  const [PlayURLbtn, setPlayURLbtn] = useState(0);
  const [PlayURLbtndata, setPlayURLbtndata] = useState(0);
  const [MainDetailsp, setMainDetailsp] = useState(true);
  const [subscribeduser, setsubscribeduser] = useState(false);
  const [showmodel, setshowmodel] = useState(undefined);
  const { content_slug } = useParams();
  const navigate = useNavigate();
  /*---------------*/
  const getData = () => {
    getGeoInfo().then((res) => {
      ContentDetails(content_slug,res).then((res) => {

        CheckUser().then((res) => {
  
          if (res?.user_data.is_subscribed == true) {
            setsubscribeduser(true)
          }
        })
        if (res.data.message && res.data.message == "session_expired") {
          navigate("/createaccount");
        }
  
        var content_details = JSON.parse(res.data);
        
        // Appsflyer("Watch Trailer Viewed", { "Title": content_details.content.title, "Contentid": content_details.content.ID })
        // branchIO("Watch Trailer Viewed", { "Title": content_details.content.title, "Contentid": content_details.content.ID })
        if (content_details.content.ID) {
  
          setDataloaded(true);
          setContent(content_details);   
         
        } else {
          setDataloaded(false);
        }
      });
    })
   
  };
  /*---------------*/
  useEffect(() => {
    getData();
  }, []);

  function Showmodels() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(true);
  }
  function Closemodel() {
    setPlayURLbtn(false);
    setMainDetailsp(true);
    setshowmodel(false);
  }
  function PlayURL(content_id, content_type) {
    setMainDetailsp(false);
    setPlayURLbtn(true);

  }

  function closePlayer() {  
    window.history.go(-1)
  }

  if (PlayURLbtn) {

    if (PlayURLbtndata.data.subtitles) {
      var content = PlayURLbtndata.data;

      var subtitles = [];
      if (content.subtitles) {
        if (content.subtitles.length > 0) {
          for (var i in content.subtitles) {
            var tempObj = {};
            tempObj["srclang"] = content.subtitles[i]['lang'];
            tempObj["label"] = content.subtitles[i]['lang'];
            tempObj["src"] = content.subtitles[i]['file'];
            subtitles.push(tempObj);
          }
        }
      }
    }

  }

  if (dataloaded == false) {
    // return <div className="loader"></div>;
    return <div className="loader"><BarLoader color="#ff000f" /></div>;
  } else {
    if(contentdata.show_details){
      var contentdata1 = contentdata.show_details;
      var contentid = contentdata.content.ID;
    }else{
      var contentdata1 = contentdata.content;
      var contentid = contentdata.content.ID;

    }
 
    return (

      <>
        <Helmet>
          <title>DocuBay-{contentdata1.title}</title>
          <meta name="description" content="" />
          <meta name="keywords" content={contentdata1.genres} />
          <meta property="og:title" content="" />
        </Helmet>
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 5}}
          key="1"
        >
        <Watchtrailer  data={contentdata1.promo_url}
                        post={contentdata1.banner_image?.medium}
                        functionclose={closePlayer}
                        Contentdata={contentdata1}
                        content_id={contentid}/>
      
        </motion.div>
      </>

    )
  }

}
